/* ══════════════════════════════════════════════════════════════════
   **Ein Papier öffnen — nicht herunterladen** (06.10.2026).

   Luca: *„Die laden immer PDFs, wenn ich in den Belegen bin. Mach doch
   einfach nur ‚Dokument öffnen' oder ‚Beleg öffnen' … Ist egal bei welchem
   Belegtyp. Es soll immer so sein."*

   Bis hierher legte jeder Belegknopf die Datei in den Download-Ordner
   (`a.download`), und man suchte sie danach dort. Jetzt geht jedes Papier
   denselben Weg wie schon das Protokoll: ein eigener Reiter, darin das PDF
   — am Schreibtisch im Betrachter des Browsers, am Telefon im Betrachter
   des Systems. Von dort lässt es sich drucken, teilen oder sichern.

   **Das Fenster geht VOR dem Abruf auf.** Ein `window.open` nach einem
   `await` hält der Browser für ein Werbefenster und blockt es. Bekommt die
   Seite trotzdem keins (Blocker), öffnet sie das PDF im selben Reiter —
   „Zurück" führt wieder her. Ohne `noopener`: Mit ihm gibt `window.open`
   kein Fenster zurück, und die Adresse ließe sich nicht mehr setzen
   (`masken/einstellungen/Dokumente.tsx`, 21.09.2026).

   **Der Server sagt `inline`** (`apps/api/src/papier/antwort.ts`) mit dem
   Dateinamen; das ist der Name, unter dem der Betrachter es speichert,
   wenn man es dort sichert. Geholt wird mit dem Kontext-Token im Kopf —
   ein nackter Link bekäme 401 —, darum der Umweg über einen Blob.
   ══════════════════════════════════════════════════════════════════ */

/** So lange bleibt die Adresse des Blobs gültig — der Reiter lädt in der Zeit. */
const HALTEN_MS = 60_000;

/**
 * Holt ein Papier und zeigt es in einem neuen Reiter. Gibt den Dateinamen
 * zurück, wie ihn der Server nannte.
 */
export async function papierOeffnen(holen: () => Promise<{ blob: Blob; name: string }>): Promise<string> {
  const fenster = window.open("", "_blank");
  try {
    const datei = await holen();
    /* Ein Blob ohne Typ zeigt kein Browser als PDF an — er böte ihn wieder
       zum Speichern an. Der Server schickt `application/pdf`; sicher ist sicher. */
    const pdf = datei.blob.type === "application/pdf"
      ? datei.blob
      : new Blob([datei.blob], { type: "application/pdf" });
    const weg = URL.createObjectURL(pdf);
    if (fenster) fenster.location.href = weg;
    else window.location.assign(weg);
    window.setTimeout(() => URL.revokeObjectURL(weg), HALTEN_MS);
    return datei.name;
  } catch (fehler) {
    fenster?.close();
    throw fehler;
  }
}
